import { render, staticRenderFns } from "./type3.vue?vue&type=template&id=29e5a708&scoped=true&"
import script from "./type3.vue?vue&type=script&lang=ts&"
export * from "./type3.vue?vue&type=script&lang=ts&"
import style0 from "./type3.vue?vue&type=style&index=0&id=29e5a708&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e5a708",
  null
  
)

export default component.exports